import React, { FC } from 'react'
import clsx from 'clsx'

import { Modal, ModalProps } from '@pepper/ui'

import { X } from 'react-feather'

import styles from './_.module.css'

interface Props extends ModalProps {
  header?: string
  subHeader?: string
  wrapClassName: string
}

const ModalView: FC<Props> = ({
  header,
  subHeader,
  children,
  wrapClassName,
  footer,
  okText,
  cancelText,
  okButtonProps,
  cancelButtonProps,
  onOk,
  onCancel,
  visible,
}) => {
  return (
    <Modal
      closable
      wrapClassName={clsx(wrapClassName, styles.wrapModal)}
      closeIcon={
        <div className={styles.closeModal}>
          <X className={styles.cross} />
        </div>
      }
      title={header}
      visible={visible}
      centered={true}
      className={styles.modalWrap}
      footer={footer}
      okText={okText}
      cancelText={cancelText}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
      onOk={onOk}
      onCancel={onCancel}
    >
      {children}
    </Modal>
  )
}

export default ModalView
